'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData from "./app.data.-App-Document-Data.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentData$Invoice$() {
}
export { $c_Lapp_data_AppDocumentData$Invoice$ as $c_Lapp_data_AppDocumentData$Invoice$ };
$p = $c_Lapp_data_AppDocumentData$Invoice$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentData$Invoice$;
/** @constructor */
function $h_Lapp_data_AppDocumentData$Invoice$() {
}
export { $h_Lapp_data_AppDocumentData$Invoice$ as $h_Lapp_data_AppDocumentData$Invoice$ };
$h_Lapp_data_AppDocumentData$Invoice$.prototype = $p;
$p.n = (function() {
  return "Invoice";
});
$p.bK8 = (function(x$0) {
  return new $j_app$002edata$002e$002dApp$002dDocument$002dData.$c_Lapp_data_AppDocumentData$Invoice(x$0.e(0));
});
$p.U = (function(p) {
  return this.bK8(p);
});
var $d_Lapp_data_AppDocumentData$Invoice$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentData$Invoice$, "app.data.AppDocumentData$Invoice$", ({
  zN: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_data_AppDocumentData$Invoice$ as $d_Lapp_data_AppDocumentData$Invoice$ };
var $n_Lapp_data_AppDocumentData$Invoice$;
function $m_Lapp_data_AppDocumentData$Invoice$() {
  if ((!$n_Lapp_data_AppDocumentData$Invoice$)) {
    $n_Lapp_data_AppDocumentData$Invoice$ = new $c_Lapp_data_AppDocumentData$Invoice$();
  }
  return $n_Lapp_data_AppDocumentData$Invoice$;
}
export { $m_Lapp_data_AppDocumentData$Invoice$ as $m_Lapp_data_AppDocumentData$Invoice$ };
//# sourceMappingURL=app.data.-App-Document-Data$-Invoice$.js.map
